import { render } from "./FormTextareaField.vue?vue&type=template&id=21b2ad8c&scoped=true"
import script from "./FormTextareaField.vue?vue&type=script&lang=js"
export * from "./FormTextareaField.vue?vue&type=script&lang=js"

import "./FormTextareaField.vue?vue&type=style&index=0&id=21b2ad8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b2ad8c"]])

export default __exports__